<template>
  <div class="min-h-screen flex flex-col justify-center relative">
    <div class="max-w-[600px] mx-auto">
      <div
        class="flex flex-col gap-y-4 bg-secondary p-4 md:p-12 shadow-xl rounded-lg"
      >
        <p class="bg-clip-text text-transparent bg-white text-4xl mx-auto">
          АТОМ
        </p>
        <input
          v-model="login"
          class="input mt-8"
          type="text"
          placeholder="Логін"
        />
        <div class="relative flex">
          <input
            ref="pass"
            v-model="password"
            id="pass-input"
            class="input relative"
            type="password"
            placeholder="Пароль"
          />
          <svg
            class="absolute top-1/4 right-2 hover:scale-95 cursor-pointer"
            height="24"
            width="24"
            @click="showPassword"
            clip-rule="evenodd"
            fill-rule="evenodd"
            stroke-linejoin="round"
            stroke-miterlimit="2"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m17.069 6.546 2.684-2.359c.143-.125.32-.187.497-.187.418 0 .75.34.75.75 0 .207-.086.414-.254.562l-16.5 14.501c-.142.126-.319.187-.496.187-.415 0-.75-.334-.75-.75 0-.207.086-.414.253-.562l2.438-2.143c-1.414-1.132-2.627-2.552-3.547-4.028-.096-.159-.144-.338-.144-.517s.049-.358.145-.517c2.111-3.39 5.775-6.483 9.853-6.483 1.815 0 3.536.593 5.071 1.546zm2.318 1.83c.967.943 1.804 2.013 2.475 3.117.092.156.138.332.138.507s-.046.351-.138.507c-2.068 3.403-5.721 6.493-9.864 6.493-1.298 0-2.553-.313-3.73-.849l2.624-2.307c.352.102.724.156 1.108.156 2.208 0 4-1.792 4-4 0-.206-.016-.408-.046-.606zm-4.932.467c-.678-.528-1.53-.843-2.455-.843-2.208 0-4 1.792-4 4 0 .741.202 1.435.553 2.03l1.16-1.019c-.137-.31-.213-.651-.213-1.011 0-1.38 1.12-2.5 2.5-2.5.474 0 .918.132 1.296.362z"
              fill-rule="nonzero"
            />
          </svg>
        </div>
        <div>
          <p class="text-white">Оберіть клуб</p>
          <select v-model="club" class="p-2 mt-2">
            <option disabled value="">Оберіть клуб</option>
            <option value="1">Василенко, 9</option>
            <option value="2">Острозького, 51</option>
          </select>
        </div>
        <button
          @click="logUser(true, login, password)"
          class="rounded-lg bg-white px-3 py-3 bg-red/20 hover:ring hover:ring-green-500 hover:bg-green-100 transition-all duration-200 mt-4"
        >
          Увійти
        </button>
      </div>
    </div>
    <Alert
      :class="this.class"
      v-bind:text="this.AlertText"
      v-bind:activErr="this.activErr"
    >
    </Alert>
  </div>
  <!-- <b-row class="d-xl-flex" style="margin-top: 200px;">
  <b-row class="input-group mb-5 text-center m-auto">
    <b-col xl="6" offset-xl="3">
      <b-input-group prepend="Логин">
        <b-form-input v-model="login" type="text" class="form-control"></b-form-input>
      </b-input-group>
    </b-col>
  </b-row>
  <b-row class="input-group mb-5 text-center mt-5 mx-auto">
    <b-col xl="6" offset-xl="3">
      <b-input-group prepend="Пароль">
        <b-form-input v-model="password" type="password" class="form-control"></b-form-input>
      </b-input-group>
    </b-col>
  </b-row>
  <b-row class="text-center m-auto">
    <b-col xl="6" offset-xl="3">
      <b-form-select class="club-select form-control m-auto" v-model="club" :options="options">
        <template #first>
          <b-form-select-option :value="null" disabled>Выберите клуб</b-form-select-option>
        </template>
      </b-form-select>
    </b-col>
  </b-row>
  <b-row class="text-center m-auto">
    <b-col xl="6" offset-xl="3">
      <b-button v-if="club" variant="primary" class="mt-2" v-on:click="logUser(true, login, password)">Войти</b-button>
    </b-col>
  </b-row>
  <Alert
      :class="this.class"
      v-bind:text="this.AlertText"
      v-bind:activErr="this.activErr">
  </Alert>
</b-row> -->
</template>

<script>
import { mapActions, mapState } from "vuex";
import Alert from "@/components/Toasts/Alert";

export default {
  name: "Login",
  components: {
    Alert,
  },
  data: function () {
    return {
      club: null,
      login: null,
      password: null,
      options: [
        { value: "1", text: "Василенко, 9" },
        { value: "2", text: "Острожского, 55" },
      ],
      class: "red",
      AlertText: "",
      activErr: false,
      birthDays: [],
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    ...mapActions(["setUser", "setClubTrainers", "logOutUser"]),
    async logUser(auth, login, pass) {
      let fd = new FormData();
      fd.append("username", login);
      fd.append("password", pass);
      fd.append("club_id", this.club);
      await this.$api.user
        .logUser(fd)
        .then((response) => {
          if (response instanceof Error) {
            this.showModalErr();
          }
          this.$cookie.set("access_token", response.data.access_token);
          this.$cookie.set("admin_id", response.data.admin_id);
          this.$cookie.set("role", response.data.role);
          this.$cookie.set("club_id", this.club);
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 401) {
            this.showModalErr();
          }
        });
      let admin = await this.$api.user.getMe().catch((err) => {
        if (err.response.status === 401) {
          this.showModalErr();
        }
      });
      await this.setUser(admin.data);
      await this.$router.push("/marketing");
    },
    showModalErr() {
      this.activErr = true;
      this.class = "red";
      this.AlertText = "Неверный логин или пароль!";
      setTimeout(() => {
        this.activErr = false;
      }, 4000);
    },
    showPassword() {
      let passInput = this.$refs.pass;
      if (passInput.type === "password") {
        passInput.type = "text";
      } else {
        passInput.type = "password";
      }
    },
  },
};
</script>

<style scoped>
.input {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding: 1rem;
  --tw-placeholder-opacity: 1;
  color: rgb(0 0 0 / var(--tw-placeholder-opacity));
  border-radius: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
</style>
